import React, { useContext } from 'react';
import { Query } from 'react-apollo';
import { ErrorScreen, Loading } from '../../components/utils';
import logo from '../../images/logo-blue.svg';
import { accountInvitationQuery } from '../../queries/account';
import {
  AccountInvitationQuery,
  AccountInvitationQueryVariables
} from '../../queries/__generated__/AccountInvitationQuery';
import JoinForm from './JoinForm';

interface JoinAccountProps {
  inviteCode: string;
}

const JoinAccount: React.FC<JoinAccountProps> = ({ inviteCode }) => {
  return (
    <Query<AccountInvitationQuery, AccountInvitationQueryVariables>
      query={accountInvitationQuery}
      variables={{ inviteCode }}
    >
      {({ data, loading, error }) => {
        if (loading) {
          return <Loading />;
        }
        if (error) {
          return <ErrorScreen error={error.message} />;
        }
        if (!data || !data.findAccountInvitation) {
          return <ErrorScreen error="No invitation found" />;
        }

        const invitation = data.findAccountInvitation;

        return (
          <div className="fixed absolute--fill flex flex-column justify-between items-center pa4">
            <img className="w3" src={logo} alt="" />
            <div>
              <h1 className="f3 f2-ns display tc mb0">
                Welcome {invitation.invitedMember.displayName}!
              </h1>
              <div className="serif lh-copy measure center f6 mb4">
                <p className="mb1">
                  {invitation.invitedBy.displayName} has invited you to join their space on Quala.
                </p>
              </div>

              <JoinForm invitation={invitation} />
            </div>
            <div />
          </div>
        );
      }}
    </Query>
  );
};

export default JoinAccount;
